// HTMLInputTypeAttribute is not in react exports for some reason
import React, { ChangeEvent, CSSProperties, ReactElement } from "react";
import styled from "styled-components";

import { PrimaryColorPalette, TextAndShapesPalette } from "lib/styles/colors";
import { TextStyles, TextType } from "lib/design-system/typography";

export enum InputTypes {
  DEFAULT = "default",
  PASSWORD = "password",
}

interface StyledInputProps {
  disabled?: boolean;
  width?: string;
}

const StyledInput = styled.input<StyledInputProps>`
  border-width: 0px;
  width: 100%;
  text-align: left;
  ${({ width }) =>
    width &&
    `
  @media screen and (min-width: 768px) {
    text-align: ${width ? "left" : "right"};
  }
  `}
  text-decoration: none;
  border: none;
  outline: none;
  background: transparent;
  padding-top: 4px;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px ${PrimaryColorPalette.MAIN_6} inset !important;
  }
  input:-internal-autofill-selected {
    background-color: transparent !important;
  }
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
  `}
`;

interface Props {
  type?: string;
  placeholder?: string;
  value?: string;
  defaultValue?: string;
  disabled?: boolean;
  width?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

/**
 * NOTE - This is just the base input section of our outer input
 * created because a bunch of other componets use this as a base to their styling
 */
export function BaseStyledInput(props: Props): ReactElement {
  const { inputStyle } = aggregateStyles(props);
  return (
    <StyledInput
      ref={props.inputRef}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
      style={inputStyle}
      defaultValue={props.defaultValue ?? undefined}
      value={props.value ?? ""}
      placeholder={props.placeholder}
      type={props.type ?? "text"}
      disabled={props.disabled ?? false}
      width={props.width ?? undefined}
    />
  );
}

function aggregateStyles(props: Props): {
  inputStyle: CSSProperties;
} {
  let inputStyle: CSSProperties = { ...TextStyles[TextType.PARAGRAPH] };

  inputStyle = {
    ...inputStyle,
    ...(!props.value && { color: PrimaryColorPalette.MAIN_3 }),
    ...(props.value && { color: TextAndShapesPalette.BRAND_BLACK }),
  };

  return {
    inputStyle,
  };
}
